export var DEXFStockProbability;
(function (DEXFStockProbability) {
    DEXFStockProbability["high"] = "HIGH_IN_STOCK";
    DEXFStockProbability["medium"] = "MEDIUM_IN_STOCK";
    DEXFStockProbability["low"] = "LOW_IN_STOCK";
    DEXFStockProbability["out"] = "OUT_OF_STOCK";
})(DEXFStockProbability || (DEXFStockProbability = {}));
export var ProductGoodToKnowTypeName;
(function (ProductGoodToKnowTypeName) {
    ProductGoodToKnowTypeName["WARNING"] = "Warning";
    ProductGoodToKnowTypeName["COMPL_ASSEMBLY_INFORMATION"] = "Compl. assembly information";
    ProductGoodToKnowTypeName["SOLD_SEPARATELY"] = "Sold separately";
})(ProductGoodToKnowTypeName || (ProductGoodToKnowTypeName = {}));
export var ImageType;
(function (ImageType) {
    ImageType["MPP"] = "Main Product Picture";
    ImageType["FPP"] = "Functional Product Picture";
    ImageType["QPP"] = "Quality Product Picture";
    ImageType["IPP"] = "Inspirational Product Picture";
    ImageType["MIP"] = "Measurement Illustration";
    ImageType["CPP"] = "Context Product Picture";
    ImageType["NSPP"] = "Non-Standardized Product Picture";
})(ImageType || (ImageType = {}));
export var VPCTypeCode;
(function (VPCTypeCode) {
    VPCTypeCode["MAIN_DESIGN_IMAGE"] = "main-design-image";
    VPCTypeCode["OPEN_DESIGN_IMAGE"] = "open-design-image";
    VPCTypeCode["ANGLED_DESIGN_IMAGE"] = "open-design-image-angled";
})(VPCTypeCode || (VPCTypeCode = {}));
export var ShapeTypeEnum;
(function (ShapeTypeEnum) {
    ShapeTypeEnum["sloped"] = "slopedRight";
    ShapeTypeEnum["slopedLeft"] = "slopedLeft";
    ShapeTypeEnum["squared"] = "squared";
    ShapeTypeEnum["off"] = "off";
    ShapeTypeEnum["squaredCornerRight"] = "squaredCornerRight";
})(ShapeTypeEnum || (ShapeTypeEnum = {}));
export var ProductType;
(function (ProductType) {
    ProductType["HANDLE"] = "handle";
    ProductType["KNOB"] = "knob";
    ProductType["EDGE_HANDLE"] = "edge-handle";
    ProductType["HANDLE_DRILL_TEMPLATE"] = "handle-drill-template";
    ProductType["CHRISTMAS_PROPPING"] = "christmas-propping";
    ProductType["PEGBOARD"] = "pegboard";
    ProductType["LIGHT_DRIVER"] = "light-driver";
    ProductType["LIGHT_CORD"] = "light-cord";
    ProductType["LIGHT_CONTROLER"] = "light-controler";
    ProductType["CLOTH_HANGERS"] = "cloth-hangers";
    ProductType["TV"] = "tv";
    ProductType["TV_WITH_FOOT"] = "tv-with-foot";
    // PAX
    ProductType["PAX_FRAME"] = "pax-hinge-frame";
    ProductType["PAX_HINGE_DOOR_ASM"] = "pax-door-assembly";
    ProductType["PAX_HINGE_DOOR"] = "pax-hinge-door-softclosing";
    ProductType["PAX_SOFT_CLOSING_HINGE"] = "pax-soft-closing-hinge";
    ProductType["PAX_SLIDING_DOOR_REGULAR_ASM"] = "pax-sliding-door-assembly";
    ProductType["PAX_SLIDING_DOOR_REGULAR_FRAME"] = "pax-sliding-door-frame";
    ProductType["PAX_SLIDING_DOOR_WITH_PANELS_ASM"] = "pax-sliding-door-with-panels-assembly";
    ProductType["PAX_SLIDING_DOOR_PANEL_FRAME"] = "pax-sliding-door-with-panels-frame";
    ProductType["PAX_SLIDING_DOOR_PANEL"] = "pax-sliding-door-panel";
    ProductType["PAX_SLIDING_DOOR_REGULAR_FRONT"] = "26106";
    ProductType["PAX_SLIDING_DOOR_PANEL_FRONT"] = "29612";
    ProductType["PAX_SOFT_CLOSING_DEVICE_SLIDING_DOORS"] = "29186";
    ProductType["PAX_SOFT_OPENING_CLOSING_DEVICE_SLIDING_DOORS"] = "35676";
    ProductType["PAX_SHELF"] = "pax-shelf";
    ProductType["PAX_MESH_BASKET_ASM"] = "pax-mesh-basket-assembly";
    ProductType["PAX_METAL_BASKET_ASM"] = "pax-metal-basket-assembly";
    ProductType["PAX_MESH_BASKET"] = "pax-mesh-basket";
    ProductType["PAX_METAL_BASKET"] = "pax-metal-basket";
    ProductType["PAX_MESH_BASKET_RAIL"] = "pax-pullout-rail-for-baskets";
    ProductType["PAX_PULL_OUT_TROUSER_HANGER"] = "pax-pull-out-trouser-hanger";
    ProductType["PAX_CLOTH_RAIL_580"] = "pax-cloth-rail-580";
    ProductType["PAX_CLOTH_RAIL_350"] = "pax-cloth-rail-350";
    ProductType["PAX_GLASS_SHELF"] = "pax-glass-shelf";
    ProductType["PAX_DRAWER"] = "pax-drawer";
    ProductType["PAX_PULL_OUT_TRAY"] = "pax-pull-out-tray";
    ProductType["PAX_PULL_OUT_TRAY_WITH_DIVIDER_INSERTS_ASM"] = "pax-pull-out-tray-with-divider-inserts";
    ProductType["PAX_PULL_OUT_TRAY_WITH_COMPARTMENT_INSERTS_ASM"] = "pax-pull-out-tray-with-comp-inserts";
    ProductType["PAX_PULL_OUT_TRAY_WITH_SHOE_INSERTS_ASM"] = "pax-pull-out-tray-with-shoe-inserts";
    ProductType["PAX_PULL_OUT_TRAY_WITH_MAT_ASM"] = "pax-pull-out-tray-with-mat";
    ProductType["PAX_PULL_OUT_TRAY_INSERT"] = "p_out_tray_insert";
    ProductType["PAX_DIVIDER_FOR_PULL_OUT_TRAY"] = "div-f-p-out-tray";
    ProductType["PAX_SHOE_INSERT_FOR_PULL_OUT_TRAY"] = "shoe-insert-f-p-out-tray";
    ProductType["PAX_INSERT_WITH_4_COMP"] = "insert-w-4-comp";
    ProductType["PAX_INSERT_FOR_JEWELLERY"] = "insert-for-jewellery";
    ProductType["PAX_DRAWER_MAT"] = "pax-drawer-mat";
    ProductType["PAX_DRAWER_BOX_ASM"] = "komp_box_set_assembly";
    ProductType["PAX_DRAWER_BOX"] = "box";
    ProductType["PAX_GLASS_DRAWER"] = "pax-glass-drawer";
    ProductType["PAX_PULL_OUT_SHOE_SHELF"] = "pax-pull-out-shoe-shelf";
    ProductType["PAX_PULL_OUT_CLOTH_RAIL"] = "pax-pull-out-cloth-rail";
    ProductType["PAX_PULL_OUT_STORAGE_BAG"] = "pax-pull-out-storage-bag";
    ProductType["PAX_DRAWER_FRAMED_GLASS"] = "pax-drawer-with-framed-glass-front";
    ProductType["PAX_DRAWER_FRAMED"] = "pax-drawer-with-framed-front";
    ProductType["PAX_DRAWER_LOCKABLE"] = "pax-drawer-lockable";
    ProductType["PAX_SHOE_SHELF"] = "pax-shoe-shelf";
    ProductType["PAX_VALET_HANGER"] = "pax-valet-hanger";
    ProductType["PAX_T_DIVIDER"] = "pax-t-divider";
    ProductType["PAX_L_DIVIDER"] = "pax-l-divider";
    ProductType["PAX_PULL_OUT_MULTI_USE_HANGER"] = "pax-pull-out-multi-use-hanger";
    ProductType["PAX_CORNER_SOLUTION_ASM"] = "pax-corner-solution";
    ProductType["PAX_ADD_ON_CORNER_FRAME_ASM"] = "pax-corner-addon-with-shelves";
    ProductType["PAX_ADD_ON_CORNER_FRAME"] = "pax-corner-addon-frame";
    ProductType["PAX_CORNER_HINGE"] = "pax-corner-hinge";
    ProductType["PAX_INNER_LIGHT"] = "light-strip";
    ProductType["PAX_INNER_LIGHT_OVERSIDAN"] = "light-strip-oversidan";
    ProductType["PAX_OUTER_LIGHT"] = "light-cabel";
    ProductType["PAX_INTERIOR_SUGGESTIONS"] = "pax-interior-suggestion";
    ProductType["PAX_SKUBB_STORAGE_CASES"] = "pax-skubb-storage-case";
    ProductType["PAX_SKUBB_SHOE_BOXES"] = "pax-skubb-shoe-box";
    ProductType["PAX_SKUBB_HANGING_STORAGE"] = "pax-skubb-hanging-storage";
    ProductType["PAX_SKUBB_STORAGE_BOXES"] = "pax-skubb-storage-box";
    ProductType["PAX_SKUBB_STORAGE_BOXES_W_COMP"] = "pax-skubb-storage-box-w-comp";
    ProductType["PAX_SKUBB_STORAGE_CASE_WRAP"] = "pax-skubb-storage-case-wrap";
    ProductType["PAX_HEMMAFIXARE_STORAGE_CASE"] = "hemmafixare-storage-case";
    ProductType["PAX_HEMMAFIXARE_STORAGE_CASE_HIGH"] = "hemmafixare-storage-case-high";
    ProductType["PAX_HEMMAFIXARE_SHOE_BOX"] = "hemmafixare-shoe-box";
    ProductType["PAX_COVER_CAPS"] = "pax-cover-caps";
    ProductType["PAX_CORNER_MEASUREMENT_FRAME"] = "pax-corner-measurement-frame";
    ProductType["PAX_SHOE_MAT"] = "pax-shoe-mat";
    ProductType["PAX_CLEANING_INTERIOR"] = "pax-cleaning-interior";
    // BESTÅ
    ProductType["BESTA_FRAME_600_ASM"] = "frame_w_legs-600-asm";
    ProductType["BESTA_FRAME_1200_ASM"] = "frame_w_legs-1200-asm";
    ProductType["BESTA_FRAME"] = "23166";
    ProductType["BESTA_TV_BENCH"] = "10333";
    ProductType["BESTA_TV_BENCH_1200_ASM"] = "tv_frame_w_legs-1200-asm";
    ProductType["BESTA_TV_BENCH_1800_ASM"] = "tv_frame_w_legs-1800-asm";
    ProductType["BESTA_SHELF"] = "10972";
    ProductType["BESTA_GLASS_SHELF"] = "10956";
    ProductType["BESTA_LEG"] = "leg";
    ProductType["BESTA_DEFAULT_LEG"] = "default-leg";
    ProductType["BESTA_SUPPORTING_LEG"] = "17808";
    ProductType["BESTA_DRAWER_FRAME"] = "31182";
    ProductType["BESTA_DRAWER_FRONT"] = "11053";
    ProductType["BESTA_DOOR_DRAWER_FRONT"] = "24179";
    ProductType["BESTA_DOOR_192_ASM"] = "door_w_hinges-1920-asm";
    ProductType["BESTA_DOOR_64_ASM"] = "door_w_hinges-640-asm";
    ProductType["BESTA_DOOR_38_ASM"] = "door_w_hinges-380-asm";
    ProductType["BESTA_PUSH_OPEN"] = "31186";
    ProductType["BESTA_SOFT_CLOSING"] = "31185";
    ProductType["BESTA_DRAWER_26_ASM"] = "drawer_w_rails_and_front-260-asm";
    ProductType["BESTA_DRAWER_38_ASM"] = "drawer_w_rails_and_front-380-asm";
    ProductType["BESTA_HINGE_DOOR_SOFT_CLOSING"] = "hinge_door_softclosing";
    ProductType["BESTA_HINGE"] = "besta-hinge";
    ProductType["BESTA_TOP_PANEL"] = "10238";
    ProductType["BESTA_TOP_PANEL_TV_BENCH"] = "29581";
    ProductType["BESTA_FRAME_SUSPENSION_RAIL"] = "19643";
    ProductType["BESTA_FRONT_LAYOUT"] = "besta-front-layout";
    ProductType["BESTA_BOTTLE_RACK"] = "bottle_rack";
    ProductType["BESTA_INNER_LIGHT"] = "besta-inner-light";
    ProductType["BESTA_SHELF_ORGANIZER"] = "besta-shelf-organizer";
    ProductType["BESTA_DRAWER_ORGANIZER"] = "besta-drawer-organizer";
    ProductType["BESTA_SHELF_AND_DRAWER_ORGANIZER"] = "besta-shelf-and-drawer-organizer";
    // PLATSA
    ProductType["PLATSA_FRAME"] = "platsa-frame";
    ProductType["PLATSA_OPEN_FRAME_SHELVES"] = "platsa-open-frame-shelves";
    ProductType["PLATSA_OPEN_FRAME_HANGING"] = "platsa-open-frame-hanging";
    ProductType["PLATSA_OPEN_FRAME_SHOES"] = "platsa-open-frame-shoes";
    ProductType["PLATSA_SHELF"] = "platsa-shelf";
    ProductType["PLATSA_SHOE_SHELF"] = "platsa-shoe-shelf";
    ProductType["PLATSA_WIRE_BASKET_ASM"] = "platsa-wire-basket-asm";
    ProductType["PLATSA_WIRE_BASKET_RAIL"] = "platsa-rail-for-baskets";
    ProductType["PLATSA_WIRE_BASKET"] = "platsa-wire-basket";
    ProductType["PLATSA_MULTIUSE_HANGER"] = "platsa-multiuse-hanger";
    ProductType["PLATSA_OUTSIDE_HOOK"] = "platsa-outside-hook";
    ProductType["PLATSA_LEG"] = "platsa-leg";
    ProductType["PLATSA_SUSPENSION_RAIL"] = "platsa-suspension-rail";
    ProductType["PLATSA_TOP"] = "platsa-top";
    ProductType["PLATSA_SLIDING_DOOR_ASM"] = "platsa-sliding-door-asm";
    ProductType["PLATSA_SLIDING_DOOR_FRONT"] = "platsa-sliding-door-front";
    ProductType["PLATSA_SLIDING_DOOR_RAIL"] = "platsa-sliding-door-rail";
    ProductType["PLATSA_SLIDING_DOOR_HANDLE"] = "platsa-sliding-door-handle";
    ProductType["PLATSA_HINGE"] = "platsa-hinge";
    ProductType["PLATSA_HINGE_DOOR_ASM"] = "platsa-hinged-door-asm";
    ProductType["PLATSA_SC_HINGE_DOOR_ASM"] = "platsa-softclosing-hinged-door-asm";
    ProductType["PLATSA_DOOR_FRONT"] = "platsa-door-front";
    ProductType["PLATSA_CLOTH_RAIL_40"] = "platsa-cloth-rail-40";
    ProductType["PLATSA_CLOTH_RAIL_55"] = "platsa-cloth-rail-55";
    ProductType["PLATSA_CLOTH_RAIL_55_W_HOOKS_ASM"] = "platsa-cloth-rail-55-w-hooks-asm";
    ProductType["PLATSA_CLOTH_RAIL_55_RAIL"] = "platsa-cloth-rail-55-rail";
    ProductType["PLATSA_INTERIOR_SUGGESTION"] = "platsa-interior-suggestion";
    ProductType["PLATSA_FRONT_LAYOUT"] = "platsa-front-layout";
    ProductType["PLATSA_DRAWER_ASM"] = "platsa-drawer-asm";
    ProductType["PLATSA_DRAWER_INSERT"] = "platsa-drawer-insert";
    ProductType["PLATSA_DRAWER_FRONT"] = "platsa-drawer-front";
    ProductType["PLATSA_HOOK"] = "platsa-hook";
    ProductType["PLATSA_RAIL_STRIP"] = "platsa-cloth-rail-strip";
    ProductType["PLATSA_RAIL_STRIP_W_HOOKS_ASM"] = "platsa-rail-strip-w-hooks-asm";
    ProductType["PLATSA_SHELF_AND_DRAWER_ORGANIZER"] = "platsa-shelf-and-drawer-organizer";
    ProductType["PLATSA_SHELF_ORGANIZER"] = "platsa-shelf-organizer";
    ProductType["PLATSA_CLOTH_RAIL_ORGANIZER"] = "platsa-cloth-rail-organizer";
    ProductType["PLATSA_INNER_LIGHT"] = "light-strip";
    // EKET
    ProductType["EKET_FRAME"] = "eket-frame";
    ProductType["EKET_MEDIA_FRAME"] = "eket-media-frame";
    ProductType["EKET_DOOR"] = "eket-door";
    ProductType["EKET_FRAME_WITH_GLASS_DOOR_ASM"] = "eket-frame-w-glass-door-asm";
    ProductType["EKET_LEG"] = "eket-leg";
    ProductType["EKET_SUSPENSION_RAIL"] = "eket-suspension-rail";
    ProductType["EKET_CONNECTION_FITTING"] = "eket-connection-fittings";
    // SMÅSTAD
    ProductType["SMASTAD_FRAME"] = "smastad-frame";
    ProductType["SMASTAD_FRAME_NA"] = "smastad-frame-na";
    ProductType["SMASTAD_FRAME_NA_ASM"] = "smastad-frame-with-drawer-na-asm";
    ProductType["SMASTAD_PULL_OUT_FRAME_108"] = "smastad-frame-w-pull-out-drawer-108";
    ProductType["SMASTAD_PULL_OUT_FRAME_196"] = "smastad-frame-w-pull-out-drawer-196";
    ProductType["SMASTAD_PULL_OUT_FRAME_DRAWER"] = "smastad-frame-w-pull-out-drawer";
    ProductType["SMASTAD_PULL_OUT_FRAME_108_ASM"] = "smastad-frame-w-pull-out-drawer-asm";
    ProductType["SMASTAD_PULL_OUT_FRAME_196_ASM"] = "smastad-frame-w-pull-out-drawer-196-asm";
    ProductType["SMASTAD_SHELF"] = "smastad-shelf";
    ProductType["SMASTAD_WIRE_BASKET_ASM"] = "smastad-wire-basket-asm";
    ProductType["SMASTAD_WIRE_BASKET_RAIL"] = "smastad-rail-for-baskets";
    ProductType["SMASTAD_WIRE_BASKET"] = "smastad-wire-basket";
    ProductType["SMASTAD_LEG"] = "smastad-leg";
    ProductType["SMASTAD_SUSPENSION_RAIL"] = "smastad-suspension-rail";
    ProductType["SMASTAD_TOP"] = "smastad-top";
    ProductType["SMASTAD_HINGE"] = "smastad-hinge";
    ProductType["SMASTAD_HINGE_DOOR_ASM"] = "smastad-hinged-door-asm";
    ProductType["SMASTAD_DOOR_FRONT"] = "smastad-door-front";
    ProductType["SMASTAD_CLOTH_RAIL_40"] = "smastad-cloth-rail-40";
    ProductType["SMASTAD_CLOTH_RAIL_ASM"] = "smastad-cloth-rail-asm";
    ProductType["SMASTAD_CLOTH_RAIL_55_W_HOOKS_ASM"] = "smastad-cloth-rail-55-w-hooks-asm";
    ProductType["SMASTAD_CLOTH_RAIL_55_RAIL"] = "smastad-cloth-rail-55-rail";
    ProductType["SMASTAD_INTERIOR_SUGGESTION"] = "smastad-interior-suggestion";
    ProductType["SMASTAD_FRONT_LAYOUT"] = "smastad-front-layout";
    ProductType["SMASTAD_DRAWER_ASM"] = "smastad-drawer-asm";
    ProductType["SMASTAD_DRAWER_INSERT"] = "smastad-drawer-insert";
    ProductType["SMASTAD_DRAWER_FRONT"] = "smastad-drawer-front";
    ProductType["SMASTAD_HOOK"] = "smastad-hook";
    ProductType["SMASTAD_RAIL_STRIP"] = "smastad-cloth-rail-strip";
    ProductType["SMASTAD_RAIL_STRIP_W_HOOKS_ASM"] = "smastad-rail-strip-w-hooks-asm";
    ProductType["SMASTAD_BENCH"] = "smastad-bench";
    ProductType["SMASTAD_BENCH_DRAWER"] = "smastad-bench-drawer";
    ProductType["SMASTAD_BENCH_WITH_DRAWER_ASM"] = "smastad-bench-with-drawer-asm";
    ProductType["SMASTAD_DESK"] = "smastad-desk";
    ProductType["SMASTAD_CHANGING_TABLE"] = "smastad-changing-table";
    ProductType["SMASTAD_DESK_W_DRAWERS_ASM"] = "smastad-desk-with-drawers-asm";
    ProductType["SMASTAD_CHANGING_TABLE_W_DRAWERS_ASM"] = "smastad-changing-table-with-drawers-asm";
    ProductType["SMASTAD_BENCH_PAD"] = "smastad-bench-pad";
    ProductType["SMASTAD_BOX"] = "smastad-box";
    ProductType["SMASTAD_HANGING_STORAGE_CASE"] = "smastad-hanging-storage-case";
    ProductType["SMASTAD_FRAME_DRAWER_NA"] = "smastad-frame-drawer";
    ProductType["SMASTAD_MIRROR"] = "smastad-mirror";
    ProductType["SMASTAD_LABEL_HOLDER"] = "smastad-label-holder";
    ProductType["SMASTAD_HOOK_CLIP"] = "smastad-hook-and-clip";
    ProductType["SMASTAD_LOFT_BED"] = "smastad-loft-bed";
    ProductType["SMASTAD_LOFT_BED_ASM"] = "smastad-loft-bed-asm";
    // IVAR
    ProductType["IVAR_SECTION"] = "section";
    ProductType["IVAR_CORNER_SECTION"] = "corner-section";
    ProductType["IVAR_CORNER_SECTION_W_SHELVES"] = "corner-section-w-inserts";
    ProductType["IVAR_SIDE_UNIT"] = "side-unit";
    ProductType["IVAR_CORNER_POST"] = "Posts";
    ProductType["IVAR_CROSS_BRACE"] = "cross-brace";
    ProductType["IVAR_SHELF_PINE"] = "shelf-pine";
    ProductType["IVAR_SHELF_FELT"] = "shelf-felt";
    ProductType["IVAR_SHELF_METAL"] = "shelf-metal";
    ProductType["IVAR_CORNER_SHELF"] = "shelf-pine-corner";
    ProductType["IVAR_BOTTLE_RACK"] = "bottle-rack";
    ProductType["IVAR_CLOTHES_RAIL"] = "clothing-rail";
    ProductType["IVAR_DRAWER_PINE"] = "drawer-pine";
    ProductType["IVAR_DRAWER_METAL"] = "drawer-metal";
    ProductType["IVAR_TABLE"] = "table";
    ProductType["IVAR_STORAGE_BOX"] = "storage-box";
    ProductType["IVAR_UNDERFRAME"] = "underframe";
    ProductType["IVAR_DOOR"] = "doors";
    ProductType["IVAR_DOOR_ADJACENT"] = "doors-adjacent";
    ProductType["IVAR_DOOR_STANDING"] = "doors-standing";
    ProductType["IVAR_HOOKS"] = "hooks";
    ProductType["IVAR_END_PROTECTORS"] = "end-protectors";
    ProductType["IVAR_CABINET"] = "cabinet";
    ProductType["IVAR_CABINET_WITH_UNDERFRAME"] = "cabinet-underframe";
    ProductType["IVAR_INTERIOR_SUGGESTION"] = "ivar-interior-suggestion";
    // BROR
    ProductType["BROR_SECTION"] = "section";
    ProductType["BROR_SHELF_METAL_BLACK"] = "shelf-metal-black";
    ProductType["BROR_SHELF_WALL_METAL_BLACK"] = "shelf-wall-metal-black";
    ProductType["BROR_FOUR_PACK_SHELF"] = "four-pack-shelf";
    ProductType["BROR_WORK_BENCH"] = "work-bench";
    ProductType["BROR_CABINET_BLACK"] = "cabinet-black";
    ProductType["BROR_CABINET_GREEN"] = "cabinet-green";
    ProductType["BROR_CABINET_FLOOR"] = "cabinet-floor";
    ProductType["BROR_WALL_SECTION_UNIT"] = "section-unit";
    ProductType["BROR_WALL_SPR"] = "wall-spr";
    ProductType["BROR_PEGBOARD_SET"] = "pegboard-set";
    ProductType["BROR_TROLLEY"] = "trolley";
    ProductType["BROR_DRAWER_METAL_BLACK"] = "drawer-metal-black";
    ProductType["BROR_SHELF_BLACK_PINE"] = "shelf-metal-black-pine";
    ProductType["BROR_SHELF_GREEN_PINE"] = "shelf-metal-green-pine";
    ProductType["BROR_RAIL"] = "rail-with-hooks";
    ProductType["BROR_INTERIOR_SUGGESTION"] = "bror-interior-suggestion";
    //ORGANIZERS
    ProductType["SAMLA_ORGANIZER"] = "samla-organizer";
    ProductType["SOCKERBIT_ORGANIZER"] = "sockerbit-organizer";
    ProductType["KUGGIS_ORGANIZER"] = "kuggis-organizer";
    ProductType["KNAGGLIG_ORGANIZER"] = "knagglig-organizer";
    ProductType["KLAMTARE_ORGANIZER"] = "klamtare-organizer";
    ProductType["RISATORP_ORGANIZER"] = "risatorp-organizer";
    // BILLY
    ProductType["BILLY_FRAME"] = "billy-frame";
    ProductType["BILLY_FRAME_WITH_SHELVES_ASM"] = "billy-frame-asm";
    ProductType["BILLY_DOOR_ASM"] = "billy-door-asm";
    ProductType["BILLY_DOOR"] = "billy-door-front";
    ProductType["BILLY_SHELF"] = "billy-shelf";
    ProductType["BILLY_DRAWER"] = "billy-drawer";
    ProductType["BILLY_FRAME_EXTENSION"] = "billy-frame-ext";
    ProductType["BILLY_CORNER_FITTING"] = "billy-corner-fitting";
    ProductType["BILLY_DESK"] = "billy-desk";
    // KALLAX
    ProductType["KALLAX_FRAME"] = "frame";
    ProductType["KALLAX_DRAWERS"] = "drawers";
    ProductType["KALLAX_CABINETS"] = "cabinets";
    ProductType["KALLAX_DIVIDERS"] = "dividers";
    ProductType["KALLAX_BOXES"] = "boxes";
    ProductType["KALLAX_BASKETS"] = "baskets";
    ProductType["KALLAX_UNDERFRAME"] = "underframe";
    ProductType["KALLAX_ASSEMBLY"] = "kallax-assembly";
    ProductType["KALLAX_DESK"] = "desk";
    ProductType["KALLAX_TV_BENCH"] = "tv-bench";
    // BOAXEL
    ProductType["BOAXEL_UPRIGHT"] = "upright";
    ProductType["BOAXEL_SHELF"] = "shelf";
    ProductType["BOAXEL_ADJ_SHELF"] = "adjustable-shelf";
    ProductType["BOAXEL_ADJ_SHELF_EXT"] = "adjustable-shelf-ext";
    ProductType["BOAXEL_ADJ_CLOTHES_RAIL_EXT"] = "adjustable-clothes-rail-ext";
    ProductType["BOAXEL_SHOE_SHELF"] = "shoe-shelf";
    ProductType["BOAXEL_WIRE_SHELF"] = "wire-shelf";
    ProductType["BOAXEL_METAL_SHELF"] = "metal-shelf";
    ProductType["BOAXEL_DRYING_RACK"] = "drying-rack";
    ProductType["BOAXEL_UPRIGHT_SECTION"] = "section";
    ProductType["BOAXEL_MESH_BASKET"] = "mesh-basket";
    ProductType["BOAXEL_CLOTHES_RAIL"] = "clothes-rail";
    ProductType["BOAXEL_ADJ_CLOTHES_RAIL"] = "adjustable-clothes-rail";
    ProductType["BOAXEL_BRACKET"] = "bracket";
    ProductType["BOAXEL_INSERT"] = "insert";
    ProductType["BOAXEL_MOUNTING_RAIL"] = "mounting-rail";
    ProductType["BOAXEL_MOUNTING_RAIL_EXT"] = "mounting-rail-ext";
    ProductType["BOAXEL_NON_MOUNTING_RAIL"] = "non-mounting-rail";
    // LADMAKARE
    ProductType["LADMAKARE_SECTION_WITH_SHELVES"] = "ladmakare-section-with-shelves";
    ProductType["LADMAKARE_SECTION"] = "ladmakare-section";
    ProductType["LADMAKARE_COMPARTMENT"] = "ladmakare-compartment";
    ProductType["LADMAKARE_SHELF"] = "ladmakare-shelf";
    ProductType["LADMAKARE_CABINET"] = "ladmakare-cabinet";
    ProductType["LADMAKARE_PANEL"] = "ladmakare-panel";
    // JONAXEL
    ProductType["JONAXEL_FRAME"] = "jonaxel-frame";
    ProductType["JONAXEL_FRAME_SHELF"] = "jonaxel-frame-shelf";
    ProductType["JONAXEL_WIRE_BASKET"] = "jonaxel-wire-basket";
    ProductType["JONAXEL_MESH_BASKET"] = "jonaxel-mesh-basket";
    ProductType["JONAXEL_TOP_SHELF"] = "jonaxel-top-shelf";
    ProductType["JONAXEL_INTERIOR_SUGGESTION"] = "jonaxel-interior-suggestion";
    ProductType["JONAXEL_CLOTH_RAIL_ADJUSTABLE"] = "jonaxel-clothing-rail-adjustable";
    // ELVARLI
    ProductType["ELVARLI_SHELF_WHITE"] = "shelf-white";
    ProductType["ELVARLI_SHELF_BAMBOO"] = "shelf-bamboo";
    ProductType["ELVARLI_SHOE_SHELF"] = "shoe-shelf";
    ProductType["ELVARLI_DRAWER"] = "drawer";
    ProductType["ELVARLI_SECTION"] = "section";
    // KNOXHULT
    ProductType["KNOXHULT_CABINET"] = "KNOXHULT-cabinet";
    ProductType["KNOXHULT_WALL_CABINET"] = "KNOXHULT-wall-cabinet";
    ProductType["KNOXHULT_CORNER_CABINET"] = "KNOXHULT-corner-cabinet";
    ProductType["KNOXHULT_HIGH_CABINET"] = "KNOXHULT-high-cabinet";
    ProductType["KNOXHULT_DOOR_FRONT"] = "KNOXHULT-door-front";
    ProductType["KNOXHULT_DRAWER_FRONT"] = "KNOXHULT-drawer-front";
    ProductType["KNOXHULT_WORKTOP"] = "KNOXHULT-worktop";
    ProductType["KNOXHULT_CABINET_ASM"] = "KNOXHULT-cabinet-asm";
    ProductType["KNOXHULT_CORNER_CABINET_ASM"] = "KNOXHULT-corner-cabinet-asm";
    ProductType["KNOXHULT_SINK_CABINET_ASM"] = "KNOXHULT-sink-cabinet-asm";
    ProductType["KNOXHULT_SINK_AND_OVEN_CABINET_ASM"] = "KNOXHULT-sink-and-oven-cabinet-asm";
    ProductType["KNOXHULT_NICHE_CABINET_ASM"] = "KNOXHULT-niche-cabinet-asm";
    ProductType["KNOXHULT_WALL_CABINET_ASM"] = "KNOXHULT-wall-cabinet-asm";
    ProductType["KNOXHULT_WALL_GLASS_CABINET_ASM"] = "KNOXHULT-wall-glass-cabinet-asm";
    ProductType["KNOXHULT_HIGH_CABINET_ASM"] = "KNOXHULT-high-cabinet-asm";
    ProductType["ENHET_WALL_FRAME"] = "wall fr w shelves";
    //Appliances
    ProductType["APPLIANCE_INTEGRATED_HOB"] = "hob";
    ProductType["APPLIANCE_INTEGRATED_OVEN"] = "integrated-oven";
    ProductType["APPLIANCE_FRIDGE_FREEZER"] = "fridge-freezer";
    ProductType["APPLIANCE_FREE_HANGING_EXTRACTOR_HOOD"] = "free-hanging-extractor-hood";
    ProductType["APPLIANCE_CABINET_EXTRACTOR_HOOD"] = "cabinet-extractor-hood";
    // Kitchen Sinks
    ProductType["KITCHEN_SINK_ASM"] = "sink";
    // Kitchen Taps
    ProductType["KITCHEN_TAP"] = "tap";
    // AURADAL
    ProductType["AURDAL_FRAME"] = "section";
    ProductType["AURDAL_SHELF"] = "shelf";
    ProductType["AURDAL_SIDEPANEL"] = "side-unit";
    ProductType["AURDAL_DRAWER"] = "drawer";
    ProductType["AURDAL_BASKET"] = "wire-basket";
    ProductType["AURDAL_SHOERACK"] = "shoe-shelf";
    ProductType["AURDAL_EXT_CLOTH_RAIL"] = "extendable-clothes-rail";
    ProductType["AURDAL_CLOTH_RAIL"] = "clothes-rail";
    ProductType["AURDAL_SUSPENSION_RAIL"] = "suspension-rail";
})(ProductType || (ProductType = {}));
export var PartKey;
(function (PartKey) {
    PartKey["CORNER_SOLUTION_NORMAL_FRAME"] = "normal-frame";
    PartKey["CORNER_SOLUTION_CORNER_FRAME"] = "corner-frame";
    PartKey["CORNER_SOLUTION_MEASUREMENT_FRAME"] = "pax-corner-measurement-frame";
    PartKey["LEG_1"] = "leg-1";
    PartKey["LEG_2"] = "leg-2";
    PartKey["LEG_3"] = "leg-3";
    PartKey["LEG_4"] = "leg-4";
    PartKey["LEG_5"] = "leg-5";
    PartKey["LEG_6"] = "leg-6";
    PartKey["LEG_7"] = "leg-7";
    PartKey["LEG_8"] = "leg-8";
    PartKey["SHARED_LEG_1"] = "leg-shared-1";
    PartKey["SHARED_LEG_2"] = "leg-shared-2";
    PartKey["TRAY"] = "tray";
    PartKey["FRAME"] = "frame";
    PartKey["SLIDING_DOOR_PANEL_FRAME_RAIL"] = "rail-frame";
    PartKey["SLIDING_DOOR_PANEL_FRAME_LEFT"] = "frame-1";
    PartKey["SLIDING_DOOR_PANEL_FRAME_RIGHT"] = "frame-2";
    PartKey["SLIDING_DOOR_REGULAR_FRAME"] = "door-frame";
    PartKey["SLIDING_DOOR_SOFT_CLOSING_DEVICE_LEFT"] = "soft-closing-1";
    PartKey["SLIDING_DOOR_SOFT_CLOSING_DEVICE_RIGHT"] = "soft-closing-2";
    PartKey["HINGE_1"] = "hinge-1";
    PartKey["HINGE_2"] = "hinge-2";
    PartKey["FRONT"] = "front";
    PartKey["DRAWER_FRAME"] = "body";
    PartKey["DRAWER_RUNNER_LEFT"] = "runner-left";
    PartKey["DRAWER_RUNNER_RIGHT"] = "runner-right";
    PartKey["SUSPENSION_RAIL_1"] = "suspension_rail-1";
    PartKey["SUSPENSION_RAIL_2"] = "suspension_rail-2";
    PartKey["DRAWER_ASSEMBLY_BODY"] = "body";
    PartKey["DRAWER_ASSEMBLY_FRONT"] = "front";
    PartKey["PANEL_1"] = "panel-1";
    PartKey["PANEL_2"] = "panel-2";
    PartKey["PANEL_3"] = "panel-3";
    PartKey["PANEL_4"] = "panel-4";
    PartKey["PANEL_5"] = "panel-5";
    PartKey["PANEL_6"] = "panel-6";
    PartKey["PANEL_7"] = "panel-7";
    PartKey["PANEL_8"] = "panel-8";
    PartKey["MAT"] = "mat";
    PartKey["IVAR_CABINET"] = "cabinet";
    PartKey["SIDE_UNIT_LEFT"] = "side-unit-left";
    PartKey["SIDE_UNIT_RIGHT"] = "side-unit-right";
    PartKey["PANEL"] = "panel-asm";
    PartKey["KNOXHULT_WORKTOP_LEFT"] = "worktop-left";
    PartKey["KNOXHULT_WORKTOP_RIGHT"] = "worktop-right";
    PartKey["KNOXHULT_WORKTOP_CENTER"] = "worktop-center";
})(PartKey || (PartKey = {}));
export var Connectors;
(function (Connectors) {
    // Pax connectors between doors and frames
    Connectors["DOOR_CONNECTION_LEFT"] = "attach-frame-left";
    Connectors["DOOR_CONNECTION_RIGHT"] = "attach-frame-right";
    Connectors["DOOR_LEFT"] = "left-door-placement";
    Connectors["DOOR_RIGHT"] = "right-door-placement";
    Connectors["DOOR_CONNECTION"] = "door-connection";
    // Bestå connectors between doors and frames
    // Right connector for besta
    Connectors["ATTACH_FRAME"] = "attach-frame";
    // Left connector for besta
    Connectors["ATTACH_FRAME_2"] = "attach-frame-2";
    // These comes numbered from right-series-1-4 for larger bestå frames 1-4 is the hole number
    Connectors["RIGHT_SERIES"] = "right-series";
    Connectors["LEFT_SERIES"] = "left-series";
    // PLATSA frame connectors
    Connectors["PLATSA_FRAME_RIGHT_SERIES"] = "right-door-series";
    Connectors["PLATSA_FRAME_LEFT_SERIES"] = "left-door-series";
    // PLATSA front connectors
    Connectors["PLATSA_FRONT_CONNECTOR_TOP"] = "attach-frame-top";
    Connectors["PLATSA_FRONT_CONNECTOR_BOTTOM"] = "attach-frame-bottom";
})(Connectors || (Connectors = {}));
export var ProductDesign;
(function (ProductDesign) {
    ProductDesign["WHITE"] = "white";
    ProductDesign["BLACK"] = "black";
    ProductDesign["BLACK_BROWN"] = "black brown";
    ProductDesign["DARK_GREY"] = "dark grey";
    ProductDesign["DARK_GREY_METAL"] = "dark grey metal";
    ProductDesign["OAK"] = "oak effect";
    ProductDesign["BLACK_OAK"] = "black oak effect";
    ProductDesign["DARK_BROWN_OAK"] = "dark brown oak effect";
    ProductDesign["GLASS"] = "glass";
    ProductDesign["BIRCH"] = "birch effect";
    ProductDesign["BROWN_STAINED_ASH"] = "brown stained ash effect";
    ProductDesign["GREY_STAINED_ASH"] = "grey stained ash effect";
    ProductDesign["WHITE_STAINED_OAK"] = "white stained oak effect";
    ProductDesign["GREY_STAINED_WALNUT"] = "grey stained walnut effect";
    ProductDesign["BEIGE"] = "beige";
    ProductDesign["LIGHT_GREEN"] = "light green";
    ProductDesign["PALE_PINK"] = "pale pink";
    ProductDesign["LIGHT_GREY"] = "light grey";
    ProductDesign["BROWN_WALNUT_EFFECT"] = "brown walnut effect";
    ProductDesign["RED_BROWN"] = "red-brown";
    ProductDesign["METAL"] = "metal";
    ProductDesign["WOOD"] = "wood";
    ProductDesign["GREY_GREEN"] = "grey-green";
    ProductDesign["LIGHT_GREY_BLUE"] = "light grey-blue";
    ProductDesign["PALE_YELLOW"] = "pale yellow";
    ProductDesign["DARK_GREEN"] = "dark green";
    ProductDesign["HIGH_GLOSS_WHITE"] = "high gloss white";
    ProductDesign["GREY_WOOD_EFFECT"] = "grey wood effect";
    ProductDesign["WALNUT_EFFECT_LIGHT_GREY"] = "walnut effect light grey";
    ProductDesign["ANTHRACITE"] = "anthracite";
    ProductDesign["METAL_WHITE"] = "metal white";
    ProductDesign["METAL_ANTHRACITE"] = "metal anthracite";
    ProductDesign["GREY"] = "grey";
    ProductDesign["WHITE_FRAME"] = "white frame";
})(ProductDesign || (ProductDesign = {}));
export var ProductIdentifiers;
(function (ProductIdentifiers) {
    ProductIdentifiers["MIRRORED_PRODUCT"] = "mirrored";
})(ProductIdentifiers || (ProductIdentifiers = {}));
export var LegacyRangeIds;
(function (LegacyRangeIds) {
    LegacyRangeIds["PAX"] = "PAX";
    LegacyRangeIds["BESTA"] = "BESTA";
    LegacyRangeIds["PLATSA"] = "PLATSA";
    LegacyRangeIds["EKET"] = "EKET";
    LegacyRangeIds["SMASTAD"] = "SMASTAD";
    LegacyRangeIds["IVAR"] = "IVAR";
    LegacyRangeIds["BROR"] = "BROR";
    LegacyRangeIds["KALLAX"] = "KALLAX";
    LegacyRangeIds["BOAXEL"] = "BOAXEL";
    LegacyRangeIds["LADMAKARE"] = "LADMAKARE";
    LegacyRangeIds["JONAXEL"] = "JONAXEL";
    LegacyRangeIds["ELVARLI"] = "ELVARLI";
})(LegacyRangeIds || (LegacyRangeIds = {}));
export var VPCImageType;
(function (VPCImageType) {
    VPCImageType["MAIN"] = "main-design-image";
    VPCImageType["OPEN_DESIGN"] = "open-design-image";
})(VPCImageType || (VPCImageType = {}));
export var AssemblyInstructionMeasurementPosition;
(function (AssemblyInstructionMeasurementPosition) {
    AssemblyInstructionMeasurementPosition["LEFT"] = "left";
    AssemblyInstructionMeasurementPosition["RIGHT"] = "right";
    AssemblyInstructionMeasurementPosition["TOP"] = "top";
    AssemblyInstructionMeasurementPosition["BOTTOM"] = "bottom";
})(AssemblyInstructionMeasurementPosition || (AssemblyInstructionMeasurementPosition = {}));
//# sourceMappingURL=types.js.map